import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ApplicationDocument } from '../models/application-document';
import { Router, ActivatedRoute } from '@angular/router';
import { ApplicationService } from 'src/app/shared/services/application.service';
import { SingleResultApiResponse } from 'src/app/shared/models/api-response.model';
import { Title } from '@angular/platform-browser';
import { Tab_Title } from 'src/app/shared/models/lookup-data.model';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'online-app-important-information',
  templateUrl: './important-information.component.html',
  styleUrls: ['./important-information.component.scss'],
  host: {
    class: 'application-section-component'
  }
})
export class ImportantInformationComponent implements OnInit {

  documents: ApplicationDocument[];
  applicationId: number;
  showModal = false;
  isSubmittedApplication = false;
  isDownloadEnglishRecommendationLetterClicked = false;
  @ViewChild('resolve') resolve: ElementRef;
  constructor(private router: Router,
    private applicationService: ApplicationService,
    private activatedRoute: ActivatedRoute,
    private titleService: Title) {
    this.activatedRoute.parent.params.subscribe( params => {
      this.applicationId = +params['id'];
    });
   }

  ngOnInit() {
    if(localStorage.getItem("isAgent") == "true"){
      this.titleService.setTitle(Tab_Title.Agent_ImportantInformation_Title);
    }else{
      this.titleService.setTitle(Tab_Title.ImportantInformation_Title);
    }
    this.documents = [
      {
        DocumentType: 'Student\'s Birth Certificate',
        ScannedCopiesOfOriginalDocument: true,
        IsEnglishTranslationRequired: true,
      },
      {
        DocumentType: 'Student\'s Passport',
        ScannedCopiesOfOriginalDocument: true,
        IsEnglishTranslationRequired: false,
      },
      {
        DocumentType: 'Student\'s Current Visa',
        ScannedCopiesOfOriginalDocument: true,
        IsEnglishTranslationRequired: false,
      },
      {
        DocumentType: 'Carer\'s Birth Certificate or Passport',
        ScannedCopiesOfOriginalDocument: true,
        IsEnglishTranslationRequired: true,
      },
      //{
      //  DocumentType: 'Carer\'s Visa or Citizenship',
      //  ScannedCopiesOfOriginalDocument: true
      //},
      {
        DocumentType: 'Parent Declaration for Guardian Visa Applicants form',
        ScannedCopiesOfOriginalDocument: true,
        DownloadLink: '/assets/docs/parent-declaration-for-guardian-visa-applicants.pdf',
      },
      {
        DocumentType: 'Direct Relative Nomination form',
        ScannedCopiesOfOriginalDocument: true,
        DownloadLink: '/assets/docs/direct-relative-nomination-v2.pdf',
      },
      {
        DocumentType: 'Parent Nomination for Homestay form',
        ScannedCopiesOfOriginalDocument: true,
        DownloadLink: '/assets/docs/parent-nomination-for-homestay-v2.pdf',
      },
      {
        DocumentType: 'Homestay Information for Parents form',
        ScannedCopiesOfOriginalDocument: true,
        DownloadLink: '/assets/docs/homestay-information-for-parents.pdf',
      },
      {
        DocumentType: 'Homestay Booking form',
        ScannedCopiesOfOriginalDocument: true,
        DownloadLink: '/assets/docs/homestay-booking-form.pdf',
      },
      {
        DocumentType: 'English teacher\'s recommendation letter',
        ScannedCopiesOfOriginalDocument: true,
        DownloadLink: 'showModal',
      },
      {
        DocumentType: 'Student\'s Academic Transcript',
        ScannedCopiesOfOriginalDocument: true,
        IsEnglishTranslationRequired: true,
      },
      {
        DocumentType: 'Student\'s Examination Results',
        ScannedCopiesOfOriginalDocument: true,
        IsEnglishTranslationRequired: true,
      },
      {
        DocumentType: 'Student\'s Current COE ',
        ScannedCopiesOfOriginalDocument: true,
      },
      {
        DocumentType: 'Student\'s Current CAAW',
        ScannedCopiesOfOriginalDocument: true,
      },
      {
        DocumentType: 'Student\'s Current OSHC Membership',
        ScannedCopiesOfOriginalDocument: true,
        IsEnglishTranslationRequired: false,
      },
      {
        DocumentType: 'GDPR Consent Form',
        ScannedCopiesOfOriginalDocument: true,
        DownloadLink: '/assets/docs/international-student-program-consent-form.pdf',
      },
      {
        DocumentType: 'Parent and Student Declaration - Terms and Conditions',
        ScannedCopiesOfOriginalDocument: true,
        DownloadLink: '/assets/docs/Parent-Student-Declaration-Terms-conditions.pdf',
      },
      {
        DocumentType: 'Legal Custodian - Evidence of Court Order',
        ScannedCopiesOfOriginalDocument: true,
        IsEnglishTranslationRequired: true,
        HelperText: 'A legal custodian is someone who has been appointed by a court of law to have legal custody of the student - for example, someone who has adopted the student. Evidence of the court order must be provided.',
      },
    ];

    this.applicationService.getApplicationDetails(this.applicationId)
      .subscribe( (response: SingleResultApiResponse) => {
          if (response.Result) {
            this.isSubmittedApplication = response.Result.ApplicationStatus === 'Submitted';
          }
        }, err => {
            console.error(err);
        });

    this.applicationService.isCovid19VaccinationNeeded(this.applicationId)
        .pipe(
          tap(
            x => {
              if (x === true) 
                this.documents = [...this.documents, 
                  {
                    DocumentType: 'COVID-19 Vaccination Parent Declaration Form',
                    ScannedCopiesOfOriginalDocument: true,
                    DownloadLink: '/assets/docs/covid-19-parent-declaration.pdf',
                    IsNew: true,
                  },
                  {
                    DocumentType: 'COVID-19 Proof of Vaccination',
                    ScannedCopiesOfOriginalDocument: true,
                    IsEnglishTranslationRequired: true,
                    IsNew: true,
                    ExternalLinkText: 'Click here for list of DE International approved vaccines.',
                    ExternalLinkUrl: 'https://www.deinternational.nsw.edu.au/news/covid-19-information-and-resources'
                  }
                ];
            }
          )
        ).subscribe();
  }

  displayModal():void {
    this.showModal = true;
    setTimeout(() => {
      this.resolve.nativeElement.focus();
    }, 100);
  }

  displayModalKeyboard():void {
    this.showModal = true;
    setTimeout(() => {
      this.resolve.nativeElement.focus();
    }, 100);
  }

  closeModal() {
    this.showModal = false;
  }

  getDocumentLink(document: ApplicationDocument): string {

    const selectedDocument = this.documents.find(doc => doc.DocumentType === document.DocumentType);

    let documentLink = '';
    if (selectedDocument) {
      documentLink = selectedDocument.DownloadLink;
    }

    return documentLink;
  }

  getYesNoText(value): string {
    if (value === true) {
      return 'Yes';
    } else if (value === false) {
      return 'No';
    } else if (value === undefined) {
      return 'N/A';
    }
    return '';
  }

  //show border when tab on link for accessibility
  linkTabAccessibility(event): void {
    event.style.outline = "1px solid black";
  }

  linkBlurAccessibility(event): void {
    event.style.outline = "";
  }

  continue() {
    this.router.navigate(['/applications', this.applicationId, 'edit', 'student-details']);
  }

  next() {
    this.router.navigate(['/applications', this.applicationId, 'edit', 'student-details']);
  }

}
